import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { Button } from "../components/button";
import { LoadingSpinner } from "../components/LoadingSpinner";
import { PublishProgressDisplay } from "../components/PublishProgressDisplay";
import { usePublishShiftsWithProgress } from "../hooks/usePublishShiftsWithProgress";

type Props = {
  startDate: Date;
  endDate: Date;
  organisation: Organisation;
  disabled?: boolean;
  title?: string;
};

export function PublishWorkedShifts(props: Props) {
  let { startDate, endDate, organisation, disabled, title } = props;
  const { executePublishShifts, hasPublishedShifts, progressList } = usePublishShiftsWithProgress();
  const progressRef = React.useRef<HTMLDivElement | null>(null);

  let onClickPublishShift = async () => {
    await executePublishShifts({
      organisation,
      startDate,
      endDate,
    });
  };

  return (
    <div className="py-1" ref={progressRef}>
      <Button
        disabled={disabled}
        title={title}
        onClick={onClickPublishShift}
        colour={hasPublishedShifts == "success" ? "success" : hasPublishedShifts == "error" ? "danger" : "accent"}
        className="flex flex-row items-center"
      >
        <FontAwesomeIcon icon="paper-plane" />
        <div className="ml-1">Publish {organisation.xero_tenantName} to Xero</div>
        {hasPublishedShifts == "success" && <FontAwesomeIcon icon="check" />}
        {progressList && !hasPublishedShifts && (
          <div className="ml-1 flex items-center">
            <LoadingSpinner />
          </div>
        )}
      </Button>

      {progressList && <PublishProgressDisplay progressList={progressList} scrollRef={progressRef} />}
    </div>
  );
}
